<template>

    <div class="tab-pane fade" id="listeProgetto" role="tabpanel">
        <h5 class="label-bar"><i class="ph-tag me-1"></i> Liste del Progetto</h5>
        <div class="cc" style="min-height: 24rem;">

            <div class="row mb-2">
                <div class="col-md-4">
                    <input type="text" class="form-control form-control-sm" placeholder="Cerca..." v-model="search.DESCRIZIONE.VALUE" />
                </div>
                <div class="col-md-4">
                    <select v-model="tipologicaFiltro" class="form-select form-select-sm">
                        <option :value="null">Tutte le tipologie</option>
                        <option v-for="tip in tipologiche" :key="tip.ID_TIPOLOGICA" :value="tip.ID_TIPOLOGICA">
                            {{ tip.DESCRIZIONE }}
                        </option>
                    </select>
                </div>
                <div class="col-md-4 d-flex align-items-center">
                    <button class="btn btn-sm btn-primary" :disabled="!tipologicaFiltro" @click="apriNuovaLista()">
                        <i class="ph-plus me-1"></i> Nuova Lista
                    </button>
                </div>
            </div>

            <div v-if="arrayOpzioniAll.length == 0" class="text-center text-muted py-4">
                <i class="ph-tag fs-1 mb-2 d-block"></i>
                Nessuna lista disponibile
            </div>

            <div v-else>
                <div class="row g-1" style="overflow-y: auto; max-height: 19rem;">
                    <div v-for="lista in paginatedList.arr" :key="lista.ID_OPZIONE_TIPOLOGICA" class="col-md-4 col-sm-6">
                        <div class="card cursor-pointer card-lista border mb-0"
                             :class="isListaAssociata(lista.ID_OPZIONE_TIPOLOGICA) ? 'border-primary bg-primary bg-opacity-10' : ''"
                             @click="toggleListaProgetto(lista)">
                            <div class="card-body p-1">
                                <div class="text-muted" style="font-size: 0.65rem; margin-bottom: 0.25rem;">
                                    {{ getDescrizioneTipologia(lista.FK_ID_TIPOLOGICA) }}
                                </div>
                                <div class="d-flex align-items-center gap-1">
                                    <i class="ph-tag" :class="isListaAssociata(lista.ID_OPZIONE_TIPOLOGICA) ? 'text-primary' : 'text-muted'"></i>
                                    <span class="fw-semibold small" :class="isListaAssociata(lista.ID_OPZIONE_TIPOLOGICA) ? 'text-primary' : ''">
                                        {{ lista.DESCRIZIONE }}
                                    </span>
                                    <i v-if="isListaAssociata(lista.ID_OPZIONE_TIPOLOGICA)" class="ph-check-circle text-primary ms-auto fs-5"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="row page-bottom" style="margin-top: 1rem; padding: 0 1rem;">
            <div class="col-12 col-md-5 d-none d-sm-block">
                <div class="d-flex align-items-center gap-3">
                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">
                        LISTE: {{ paginatedList.count }}
                    </span>
                </div>
            </div>
            <div class="col-9 col-md-6">
                <div class="float-end pag-mobile">
                    <Pagine v-model="search.PAGINATION.PAGE_NUMBER"
                        :numrighe="paginatedList.count"
                        :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
                </div>
            </div>
            <div class="col-3 col-md-1">
                <select class="form-select form-select-sm wmin-100 mt-2 float-end"
                    data-placeholder="Limite" :tabindex="20"
                    v-model="search.PAGINATION.PAGE_SIZE"
                    style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                </select>
            </div>
        </div>
    </div>

    <!-- Modal Nuova Lista -->
    <div class="modal fade" :id="'popUpNuovaLista' + rs" role="dialog" data-bs-backdrop="static">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"><i class="ph-plus me-2"></i>Nuova Lista</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label">Descrizione</label>
                        <input type="text" class="form-control form-control-sm" v-model="nuovaLista.DESCRIZIONE" placeholder="Inserire la descrizione della lista">
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Tipologia</label>
                        <select v-model="nuovaLista.FK_ID_TIPOLOGICA" class="form-select form-select-sm">
                            <option v-for="tip in tipologiche" :key="tip.ID_TIPOLOGICA" :value="tip.ID_TIPOLOGICA">
                                {{ tip.DESCRIZIONE }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Annulla</button>
                    <button type="button" class="btn btn-sm btn-primary" @click="salvaNuovaLista()">Salva</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'

export default {
    name: 'TabCitta',

    components: { Pagine },

    emits: ['updateGriglia'],

    props: {
        progetto: { type: Object, required: true }
    },

    data() {
        return {
            listeAssociateIds: [],
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
                DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
            },
            arrayOpzioniAll: new Array(),
            tipologiche: [],
            tipologicaFiltro: null,
            rs: utils.generateRandomString(10),
            nuovaLista: { ID_OPZIONE_TIPOLOGICA: 0, FK_ID_TIPOLOGICA: null, DESCRIZIONE: '', FLG_ATTIVO: 1 },
        }
    },

    computed: {
        paginatedList() {
            let arr = this.arrayOpzioniAll
            if (this.tipologicaFiltro) {
                arr = arr.filter(o => o.FK_ID_TIPOLOGICA == this.tipologicaFiltro)
            }
            return utils.inGrid(arr, this.search)
        }
    },

    mounted() {
        this.load()
    },

    methods: {
        _updateArrayOpzioni() {
            if (this.tipologiche.length > 0 && this.$root.arrayAllOpzioni.length > 0) {
                const tipIds = this.tipologiche.map(t => t.ID_TIPOLOGICA)
                this.arrayOpzioniAll = this.$root.arrayAllOpzioni.filter(o => tipIds.includes(o.FK_ID_TIPOLOGICA))
            } else {
                this.arrayOpzioniAll = []
            }
        },

        load() {
            utils.ajax('shared/tipologiche', { FK_ID_MODULO: 11 }, (res) => {
                if (res.esito == 0) {
                    this.tipologiche = res.data || []
                    this._updateArrayOpzioni()
                }
            })
            this.loadListeIds()
        },

        loadListeIds() {
            utils.ajax('theb/progetto/liste/ids', { ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
                this.listeAssociateIds = response.data || []
            })
        },

        isListaAssociata(idLista) {
            return this.listeAssociateIds.includes(idLista)
        },

        getDescrizioneTipologia(fkIdTipologica) {
            const tip = this.tipologiche.find(t => t.ID_TIPOLOGICA === fkIdTipologica)
            return tip ? tip.DESCRIZIONE : ''
        },

        toggleListaProgetto(lista) {
            utils.ajax('theb/progetto/liste/toggle', { ID_PROGETTO: this.progetto.ID_PROGETTO, ID_OPZIONE_TIPOLOGICA: lista.ID_OPZIONE_TIPOLOGICA}, (response) => {
                if (response.esito == 0) {
                    utils.alert.success(response.messaggio)
                    this.loadListeIds()
                    this.$emit('updateGriglia')
                }
            })
        },

        apriNuovaLista() {
            this.nuovaLista = { ID_OPZIONE_TIPOLOGICA: 0, FK_ID_TIPOLOGICA: this.tipologicaFiltro, DESCRIZIONE: '', FLG_ATTIVO: 1 }
            filters.openPopUp('popUpNuovaLista' + this.rs)
        },

        salvaNuovaLista() {
            if (!this.nuovaLista.DESCRIZIONE.trim()) {
                utils.alert.warning('Inserire una descrizione')
                return
            }
            utils.ajax('shared/tipologica/opzione/insert', this.nuovaLista, (response) => {
                if (response.esito == 0) {
                    utils.alert.success(response.messaggio)
                    filters.closePopUp('popUpNuovaLista' + this.rs)
                    this.$root.startUp()
                    this.load()
                }
            })
        },

    },

    watch: {
        tipologicaFiltro() {
            this.search.PAGINATION.PAGE_NUMBER = 1
        }
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    transition: all 0.2s ease;
}

.cursor-pointer:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-lista {
    height: 55px;
}
</style>
